export default __webpack_public_path__ + "static/media/broken-link.c26eee4a.svg";